module.exports = __webpack_public_path__ + "static/media/SM-MT-6.09c7a473.mp3";